export const selectLoading = state => state.app.loading;
export const selectSession = state => state.app.session;
export const selectClinic = state => state.app.clinic;
export const selectQrcToken = state => state.app.qrcToken;
